
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CardWithButton from '../../../components/Comman/button-new';
import AddIcon from "@mui/icons-material/Add";
import BlogForm from './BlogForm';
import BlogView from './BlogView';
import CommonDialog from './CommonDialog';
import TableComponent from '../../../components/blogComp/TableComponent';
import { FaToggleOff, FaTrashAlt, FaEdit, FaEye, } from 'react-icons/fa';
import { createBlog, deleteBlog, getBlogs, updateBlog, viewBlog } from '../../../redux/actions/blogs.actions';
import { createCategory, deleteCategory, getCategories, updateCategory } from '../../../redux/actions/categories.action';
import TableShimmer from './TableShimmer';
import { blogSchema, categorySchema } from './categoryYup';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { SiHappycow } from "react-icons/si";


const BlogPage = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [sections, setSections] = useState({
        blog: false,
        category: true,
        blogForm: "",
        categoryForm: "",
    });
    const [categoryName, setCategoryName] = useState("");
      const [currentPage, setCurrentPage] = useState(1);


    // Add state to control modal open & selected blog
    const [viewOpen, setViewOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);


    // Get blogs and categories
    const { categories, isCategoryLoading, blogs, viewedBlog, blogsCategory } = useSelector((state) => {
        return {
            categories: state.categoryReducer.categories,
            isCategoryLoading: state.categoryReducer?.isCatLoading,
            blogs: state.blogsReducer.blogs?.data,
            viewedBlog: state.blogsReducer.viewedBlog,
            blogsCategory: state.categoryReducer.categories?.map((cat) => {
                return {
                    id: cat.id,
                    title: cat.title,
                };
            }),
        }
    });


    useEffect(() => {
        // Fetch categories on initial load
        dispatch(getCategories());
    }, [dispatch]);

    useEffect(() => {
        if (viewedBlog && sections.blogForm === "Update") {
            methods.reset(viewedBlog);
            setOpen(true);
        }
    }, [viewedBlog, sections.blogForm]);

    const handleClickOpen = () => {
        setSections({ blog: true, category: false, blogForm: "Create" });
        dispatch(getBlogs()); // Fetch blogs when blog section is opened
    };

    const handleClickOpenCategory = () => {
        setSections({ blog: false, category: true, categoryForm: "Create" });
        dispatch(getCategories());
    };

    const handleClose = () => {
        setOpen(false);
        setSections({ ...sections, blogForm: "", categoryForm: "" });
        methods.clearErrors();
        setCategoryName(``)
        methods.reset(sections.blog ? arrSections[0] : arrSections[1]);
    }

    const handleFormSubmit = async (data) => { // ✅ Updated: make function async
        if (sections.blogForm === "Create") {
            if (data?.cover_video === "") delete data?.cover_video;
            if (data?.cover_image === "") delete data?.cover_image;
            if (data?.blog_desktop_banner === "") delete data?.blog_desktop_banner;
            if (data?.blog_mobile_banner === "") delete data?.blog_mobile_banner;
            if (data?.text_editor === "") delete data?.text_editor;

            // ✅ Wait for createBlog to complete before fetching blogs
            await dispatch(createBlog(data));

            // ✅ Fetch updated blogs after creation
            dispatch(getBlogs());

            methods.reset(sections.blog ? arrSections[0] : arrSections[1]);
        } else if (sections.categoryForm === "Create") {
            await dispatch(createCategory(data));
            dispatch(getCategories());
            methods.reset(sections.blog ? arrSections[0] : arrSections[1]);
        } else if (sections.categoryForm === "Update") {
            await dispatch(updateCategory(data?.id, data));
            dispatch(getCategories());
            methods.reset(sections.blog ? arrSections[0] : arrSections[1]);
        }
        else if (sections.blogForm === "Update") {
            if (!data.cover_video) data.cover_video = null;
            if (!data.cover_image) data.cover_image = null;
            if (!data.blog_desktop_banner) data.blog_desktop_banner = null;
            if (!data.blog_mobile_banner) data.blog_mobile_banner = null;
            if (!data.text_editor) data.text_editor = null;


            // await dispatch(updateBlog(data?.id, data)); // previous: relied on form id (not registered), causing no API call
            const updateId = data?.id || viewedBlog?.id; // updated: fallback to the viewed blog id from store
            await dispatch(updateBlog(updateId, data));
            dispatch(getBlogs());
            methods.reset(sections.blog ? arrSections[0] : arrSections[1]);
        }

        handleClose();
    };


    const handleCreate = (sectionItem) => {
        if (sectionItem === "blog") {
            setSections({ ...sections, blogForm: "Create" });
        } else {
            setSections({ ...sections, categoryForm: "Create" });
        }
        setOpen(true);

    };

    const handleSearch = (searchTerm) => {
        dispatch(getBlogs(1,10,`search=${searchTerm}`));
    };


    const onEditClick = (item) => {
        if (sections.blog) {
            setSections({ ...sections, blogForm: "Update" });
            const catId=item.categoryId;
            const category = blogsCategory.find(cat => cat.id === catId);
            setCategoryName(category ? category.title : "");
            dispatch(viewBlog(item.id));
        } else {
            setSections({ ...sections, categoryForm: "Update" });
            setSelectedItem(item);
            methods.reset(item); // updated: prefill Category form with selected item
            setOpen(true);
        }

    };

    const onDeleteClick = (item) => {
        if (sections.blog) {
            dispatch(deleteBlog(item?.id));
        } else {
            dispatch(deleteCategory(item?.id));
        }
    };

    const onViewClick = (item) => {
        dispatch(viewBlog(item.id));
        setViewOpen(true);
    };


    const blogColumns = [
        { key: 'id', title: 'ID', width: "100px", maxWidth: "200px" },
        { key: 'title', title: 'Title', width: "200px", maxWidth: "500px" },
        {
            key: 'media',
            title: 'Media',
            width: "150px",
            maxWidth: "100%",
            render: (item) => {
                if (item.cover_image) {
                    return (
                        <img
                            src={item.cover_image}
                            alt="Cover"
                            style={{ width: '100px', height: '60px', objectFit: 'cover', borderRadius: "5px" }}
                        />
                    );
                } else if (item.cover_video) {
                    return (
                        <video
                            src={item.cover_video}
                            controls
                            style={{ width: '100px', height: '60px', objectFit: 'cover' }}
                        />
                    );
                } else {
                    return <span>No Media</span>;
                }
            }
        },
        {
            key: 'actions',
            title: 'Actions',
            render: (item) => (
                <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-outline-success" onClick={() => onViewClick(item)}>
                        <FaEye />
                    </button>
                    <button className="btn btn-sm btn-outline-primary" onClick={() => onEditClick(item)}>
                        <FaEdit />
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => onDeleteClick(item)}>
                        <FaTrashAlt />
                    </button>
                </div>
            )
        }
    ];

    const categoryColumns = [
        { key: 'id', title: 'ID', width: "100px", maxWidth: "100%" },
        { key: 'title', title: 'Title' },
        { key: 'description', title: 'Description', width: "100px", maxWidth: "200px" },

        {
            key: 'status', title: 'Status',
            render: (item) => (
                <div style={{
                    marginLeft: "1rem"
                }}>
                    {item.status ? (
                        <SiHappycow className="text-success" size={24} />
                    ) : (
                        <FaToggleOff className="text-secondary" size={24} />
                    )}
                </div>
            )
        },
        {
            key: 'actions',
            title: 'Actions',
            render: (item) => (
                <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-outline-primary" onClick={() => onEditClick(item)}>
                        <FaEdit />
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => onDeleteClick(item)}>
                        <FaTrashAlt />
                    </button>
                </div>
            )
        }
    ];

    const arrSections = [
        {
            title: '',
            cover_image: '',
            cover_video: '',
            blog_desktop_banner: '',
            blog_mobile_banner: '',
            text_editor: '',
            publisher: '',
            redirectional_url: '',
            categoryId: '',
            blog_for: ''
        },
        {
            title: '',
            description: '',
            order: ''
        }
    ]

    const methods = useForm({
        defaultValues: sections.blog ? arrSections[0] : arrSections[1],
        resolver: yupResolver(sections.blog ? blogSchema : categorySchema)
    });



    return (
        <>
            <div className='mt-4'>
                <CardWithButton
                    title="Add Your Blogs and Categories Here ..."
                    buttonLabel="Category"
                    buttonLabelTwo="Blog "
                    buttonIcon={<AddIcon />}
                    buttonClick={handleClickOpenCategory}
                    buttonClickTwo={handleClickOpen}
                    isBlogActive={sections.blog}
                />
            </div>
            {
                isCategoryLoading && <TableShimmer />
            }

            {sections.blog && (
                <TableComponent
                    columns={blogColumns}
                    data={blogs?.data || []}
                    createButtonText="Add Blog"
                    onCreateClick={() => handleCreate("blog")}
                    searchPlaceholder="Search blogs..."
                    onSearch={handleSearch}
                    pagination={true}
                    cardTitle={"Blog Entries"}
                    itemsPerPage={5}
                    hideSearch={true}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                />
            )}
            {sections.category && (
                <TableComponent
                    columns={categoryColumns}
                    data={categories}
                    cardTitle={"Category Entries"}
                    createButtonText={"Add Category"}
                    onCreateClick={() => handleCreate("category")}
                    searchPlaceholder="Search categories..."
                    onSearch={handleSearch}
                    pagination={true}
                    itemsPerPage={5}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            )}

            <FormProvider {...methods}>
                <CommonDialog
                    open={open}
                    onClose={handleClose}
                    title={sections.blog ? sections?.blogForm === "Create" ? "Create New Blog" : "Update Blog" : sections?.categoryForm === "Create" ? "Create New Category" : "Update Category"}
                    maxWidth="md"
                    fullWidth
                    onConfirm={methods.handleSubmit(handleFormSubmit)}
                    hideActions
                    formId="blogForm"
                    confirmText={sections.blog ? sections?.blogForm === "Create" ? "Create Blog" : "Update Blog" : sections?.categoryForm === "Create" ? "Create Category" : "Update Category"}

                >
                    <BlogForm
                        FormName={sections.blog ? "Blog" : "Category"}
                        initialValues={sections.categoryForm === "Update" && !sections.blog ? selectedItem : sections.blogForm === "Update" && sections.blog ? viewedBlog : sections.blog ? arrSections[0] : arrSections[1]}
                        yupSchema={sections.blog ? blogSchema : categorySchema}
                        categories={blogsCategory}
                        categoryName={categoryName}
                        setCategoryName={setCategoryName}
                        isEditMode={sections.blogForm === "Update"}
                    />
                </CommonDialog>
                {/* ✅ BlogView Modal */}
                <CommonDialog
                    open={viewOpen}
                    onClose={() => setViewOpen(false)}
                    title="Blog Details"
                    hideButtons={true}

                >
                    <BlogView
                        open={viewOpen}
                        onClose={() => setViewOpen(false)}
                        blog={viewedBlog}
                    />
                </CommonDialog>


            </FormProvider >

        </>
    );
};

export default BlogPage;
